import emailTemplateForm from './_form'
import template from './edit.pug'

export default Vue.extend({
  template: template(),
  components: {
    emailTemplateForm
  },
  data() {
    return {
      ready: false,
      data: {},
      errors: {}
    }
  },
  watch: {
    '$route.params.id': {
      immediate: true,
      handler() {
        this.$setPageTitle(this.$t('emailMarketing.edit.title'))
        this.loadData()
      }
    }
  },

  methods: {
    loadData() {
      this.ready = false
      API.emailMarketing.show(this.$route.params.id).then(response => {
        this.data = response
        this.ready = true

        this.$setBreadcrumbs([
          // eslint-disable-next-line max-len
          {label: this.$t('breadcrumbs.emailMarketing.index'), route: {name: 'email-marketing-index'}},
          {label: this.$t('breadcrumbs.emailMarketing.edit', {name: this.data.name}), route: {}}
        ])
      })
    },

    updateEmailTemplate(data) {
      API.emailMarketing.update(this.$route.params.id, data).then(() => {
        this.$notifications.success(this.$t('targetNumbers.edit.succesfullyUpdated'))
        this.$router.push({name: 'email-marketing-index'})
      }, errors => {
        this.errors = errors
      })
    }
  }
})
